export const MAX_NUMBER_OF_POSSIBLE_GAMES_PER_MATCH = 3;
